<template lang='pug'>
  header
    .container-content-header(v-if="!noHeader")
      .display-block 
        slot(name="left")
      .display-block 
        slot(name="right")
    .container-content
      slot
</template>

<script>
export default {
  props: {
    noHeader: {
      type:     Boolean,
      default:  false,
    }
  }
};
</script>


<style lang="less">
  @import "../assets/variables";
  .container-content-header {
    display:      flex;
    align-items:  center;
    justify-content: space-between;
    height:       50px;
    
    h3 {
      margin:     0;
      font-size:  @font-size-primary;
      font-weight: normal;
    }
  }

  .container-content {
    width:      100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/contentHeader.vue